import React from 'react';

import CheckoutAlertListener from 'common/components/CheckoutAlertListener';

const CartSectionHeaderAlert = () => (
  <CheckoutAlertListener
    scrollOnError
    initialErrorDetail={null}
    mt="sp_16"
    mb="sp_0"
    key={Math.random()}
  />
);

export default CartSectionHeaderAlert;
